import { Notifications } from "./Notification";
import UnitSystem from "./UnitSystem";
import { SystemMode } from "./SystemMode";
import { DeveloperMenuSettings } from "./DeveloperMenu";

export interface DeviceSystemMode {
  isLocked?: boolean;
  shouldInherit?: boolean;
  lastKnown?: SystemMode;
  target?: SystemMode;
  revertMode?: SystemMode;
  revertMinutes?: number;
}

export enum ValveState {
  OPEN, CLOSED, IN_TRANSITION, UNKNOWN
}

export interface DeviceValve {
  target?: ValveState;
  lastKnown: ValveState;
}

export enum DeviceType { DETECTOR, SHUTOFF }

export interface Measure {
  value: number;
  unit: UnitSystem;
  short: string;
  long: string;
}

export interface Telemetry {
  flow: Measure;
  pressure: Measure;
  humidity: Measure;
  battery: Measure;
  temp: Measure;
  updated: string;
}

export interface Device {
  id: string;
  isConnected: boolean;
  macAddress: string;
  nickname: string;
  type: DeviceType;
  isPaired?: boolean;
  systemMode: DeviceSystemMode;
  valve: DeviceValve;
  telemetry: Telemetry;
  notifications?: Notifications;
  hardwareThresholds?: DeviceHardwareThresholds;
  developerMenuSettings?: DeveloperMenuSettings;
  fwProperties?: FwProperties;
}

export interface FwProperties {
  player_action: string;
  player_flow: number;
  player_pressure: number;
  player_min_pressure: number;
  player_temperature: number;
}
export interface DeviceHardwareThresholds {
  tempF: HardwareThresholds,
  tempC: HardwareThresholds,
  humidity: HardwareThresholds,
  battery: HardwareThresholds,
  tempEnabled: boolean,
  humidityEnabled: boolean,
  batteryEnabled: boolean
}

export interface HardwareThresholds{
  okMin: number;
  okMax: number;
  minValue: number;
  maxValue: number;
}
export interface Detector extends Device {
  isDetectingWater: boolean;
}

export interface RealTimeDeviceData {
  macAddress: string;
  notifications?: Notifications;
  isConnected: boolean;
  systemMode?: DeviceSystemMode;
  valve?: DeviceValve;
  telemetry: Telemetry;
}

export default Device;